import axiosApi from '@klinx/utils/api/axios-api.js';

export default {
  // ---------------------- 料单管理 ---------------------
  // 料单分页查询
  getDyesList(data) {
    return axiosApi({
      url: '/icas/casStuffList/page',
      method: 'POST',
      data
    });
  },
  // 料单单位设置
  unitConversion(data) {
    return axiosApi({
      url: `/icas/casStuffList/unitConversion?unit=${data.unit}&deviceType=${data.deviceType}`,
      method: 'POST'
    });
  },
  // 删除料单
  delStuffList(data) {
    return axiosApi({
      url: '/icas/casStuffList',
      method: 'DELETE',
      data
    });
  },
  // 获取料单号
  getStuffCode(deviceType) {
    return axiosApi({
      url: `/icas/casStuffList/stuffCode/get?deviceType=${deviceType}`,
      method: 'POST'
    });
  },
  // 复制料单号
  copyStuffCode(data) {
    return axiosApi({
      url: '/icas/casStuffList/copy',
      method: 'POST',
      data
    });
  },
  // 更新领料状态
  updateStuffStatus(data) {
    return axiosApi({
      url: '/icas/casStuffList/updateStatus',
      method: 'POST',
      data
    });
  },
  // 获取单体料单明细数据
  getSingleStuffData(id) {
    return axiosApi({
      url: `/icas/casStuffList/${id}`,
      method: 'GET'
    });
  },
  // 根据料单号获取单体料单明细数据
  getSingleByRms(data) {
    return axiosApi({
      url: `/icas/casStuffList/getSingleByRms`,
      method: 'GET',
      data
    });
  },
  // 计算用料
  calculateStuffData(data) {
    return axiosApi({
      url: '/icas/casStuffList/calculation',
      method: 'POST',
      data
    });
  },
  // 新增料单
  addStuffList(data) {
    return axiosApi({
      url: '/icas/casStuffList',
      method: 'POST',
      data
    });
  },
  // 编辑料单
  editStuffList(data) {
    return axiosApi({
      url: '/icas/casStuffList',
      method: 'PUT',
      data
    });
  },
  // 校验批次号与工序
  validateStuff(data) {
    return axiosApi({
      url: '/icas/casStuffList/validate',
      method: 'POST',
      data
    });
  },
  // 退出编辑解锁订单号
  unLock(stuffCode) {
    return axiosApi({
      url: `/icas/casStuffList/stuffCode/unLock/${stuffCode}`,
      method: 'POST'
    });
  },
  // 获取默认单位
  getDefaultUnit(deviceType) {
    return axiosApi({
      url: `/icas/casStuffList/getDefaultUnit?deviceType=${deviceType}`,
      method: 'GET'
    });
  },
  // 料单一键排程
  addBatchPlan(data) {
    return axiosApi({
      url: `/icas/casStuffList/batchPlan/add?customizeBatch=${data.customizeBatch}&stuffCode=${data.stuffCode}`,
      method: 'POST'
    });
  },
  // 料单一键排程弹出框
  popupBatchPlan(stuffCode) {
    return axiosApi({
      url: `/icas/casStuffList/batchPlan/popup/${stuffCode}`,
      method: 'POST'
    });
  },
  // 通知称料系统
  setStuffListNotice(stuffCode) {
    return axiosApi({
      url: `/icas/casStuffList/notice/${stuffCode}`,
      method: 'POST'
    });
  },
  // 料单备落料情况API
  getStuffCondition(data) {
    return axiosApi({
      url: `/icas/casStuffRecord/getStuffCondition?stuffCodes[]=${data.stuffCodes}&deviceType=${data.deviceType || 'DYEING'}`,
      method: 'GET'
    });
  },
  // ---------------批次参数设定--------------------
  // 机台获取批次参数设定
  getBatchParamsByDevice(deviceId) {
    return axiosApi({
      url: `/icas/casBatchParameters/device/get/${deviceId}`,
      method: 'GET'
    });
  },
  // 保存批次参数设定
  saveBatchParameters(data) {
    return axiosApi({
      url: `/icas/casBatchParameters/edit`,
      method: 'POST',
      data
    });
  },
  // 架构获取批次参数设定
  getBatchParamsByArchitecture(architectureId) {
    return axiosApi({
      url: `/icas/casBatchParameters/get/${architectureId}`,
      method: 'GET',
      selfHandleSuccess: true
    });
  },
  // 计算批次参数
  calculateBatchParameters(data) {
    return axiosApi({
      url: `/icas/casBatchParameters/calculate`,
      method: 'POST',
      data
    });
  },
  // 机台获取批次参数设定
  getBatchParametersSetting(deviceId) {
    return axiosApi({
      url: `/icas/casBatchParameters/device/get/${deviceId}`,
      method: 'GET'
    });
  },
  // ----------------输料中间表-----------------------
  // 呼料-加载料单
  getCasStuffRecordCallLoad(data) {
    return axiosApi({
      url: `/icas/casStuffRecord/call/load?deviceType=${data.deviceType}&stuffCode=${data.stuffCode}&batchReferenceNo=${data.batchReferenceNo}`,
      method: 'POST',
      data
    });
  },
  // 呼料-呼叫打料
  setCasStuffRecordCall(data) {
    return axiosApi({
      url: `/icas/casStuffRecord/call`,
      method: 'POST',
      data
    });
  },
  // 呼叫任务修改明细
  editCallRecord(data) {
    return axiosApi({
      url: `/icas/casStuffRecord/editCallRecord`,
      method: 'POST',
      data
    });
  }
};

